import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { getDateTimeString } from '@acri-tools/react-tools/utils/date';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import classNames from 'classnames';
import React,{Component} from 'react';
import { DOCUMENT_CATEGORIES, get_categroy_group } from '../../utils/documents';
import DocumentForm from '../DocumentForm/DocumentForm';

import './CreateDocument.css';

interface Props{
    onCreate?: Function
    category?: string
}
interface State{
    creating: boolean

    // Creation 
    document: any
}



export default class CreateDocument extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            creating: false,
            // creating: false,
            document: {
                ...this.default_values()
            }
        }
    }

    default_values = (category?:string) => {
        if(!category) category = this.props.category || Object.values(DOCUMENT_CATEGORIES)[0][0] || '';
        return {
            category,
            category_group: get_categroy_group(category),
            version: 1.0,
            name: '',
            file: '',
            modification_date: getDateTimeString(new Date(), true)
        }
    }

    componentDidUpdate(prevProps:Props){
        if(prevProps.category !== this.props.category){
            let { document } = this.state;
            document.category = this.props.category;
            this.setState({ document })
        }
    }
    
    render(){
        return (
            <div className="create-request">
                {/* <Optional>*Required</Optional> */}
                {/* <br/>
                <br/> */}

                <DocumentForm
                    document={this.state.document}
                    onChange={(updates:any)=>{
                        this.setState({
                            document: {
                                ...this.state.document,
                                ...updates
                            }
                        });
                    }}
                />

                <br/>
                <br/>
                <div className="centered">
                    <div 
                        className={classNames({
                            "custom-button blue inline medium": true,
                            "disabled": this.state.creating
                        })}
                        onClick={this.create}
                    >
                        {
                            this.state.creating ? 
                            <Spinner height={15} white/>:
                            <><i className="fas fa-plus"/> ADD DOCUMENT</>
                        }

                    </div>
                </div>
            </div>
        );
    }


    create = async() =>{
        let { document } = this.state;

        var body = new FormData();
        
        for(let attr of Object.keys(document)){
            if(attr === "category_group") continue;
            if(attr === "file") body.append('file', document.file);
            else if(document[attr]) body.append(attr, document[attr]);
        }

        this.setState({ creating: true })
        try{
            let res = await request(`${API_URL}/api/v1/documents`,{
                method:'post',
                data: body
            })

            this.props.onCreate?.();
            this.setState({
                document: this.default_values(document.category)
            });

            create_toast({ type: 'success', message: `Successfully created document ${res.data.value.name}` })

            // console.log("this.state", this.state);
        }
        catch(e:any){
            axiosErrorHandler( e, { 
                functionName: 'create'
            })
            toast_request_error(e);
        }
        finally{
            this.setState({ creating: false })
        }
    }
};